import {Observable} from 'rxjs';
import {inject, Inject, Injectable} from '@angular/core';

import {AppConfigPort} from '@features/app-config/application/ports/app-config.port';
import {GetConfigUseCasePort} from '@features/app-config/application/use_cases/get-config//get-config.use-case.port';

import {GetConfigResponseDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.response.dto';
import {GetConfigPayloadDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.payload.dto';
import {ThemePort} from '@shared/application/ports/theme/theme.port';
import {ThemeEntity} from '@shared/domain/entities/theme/theme.entity';
import {tap} from 'rxjs/operators';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';


@Injectable()
export class GetConfigUseCase implements GetConfigUseCasePort {

  private readonly localStorage: LocalStoragePort = inject(LocalStoragePort);

  constructor(
    @Inject(AppConfigPort)
    private readonly port: AppConfigPort,
    @Inject(ThemePort)
    private readonly themePort: ThemePort
  ) {
  }

  public execute(payload: GetConfigPayloadDto): Observable<GetConfigResponseDto> {
    return this.port.getConfig(payload)
      .pipe(
        tap((response) => {
          this.localStorage.setByKey("_company_id", response.tenantConfig.companyId);
          this.themePort.setThemes([
            ThemeEntity.create({
              code: "light",
              name: "Claro",
              primary: response.themeConfig.colors.primary,
              secondary: response.themeConfig.colors.secondary,
              surface: '#FFFFFF',
              surfaceVariant: '#F5F5F5',
              text: '#171717',
              textVariant: '#525252',
            }),
            ThemeEntity.create({
              code: 'dark',
              name: 'Oscuro',
              primary: response.themeConfig.colors.primary,
              secondary: response.themeConfig.colors.secondary,
              surface: '#111827',         // Gray 900
              surfaceVariant: '#1F2937',  // Gray 800
              text: '#F9FAFB',            // Gray 50
              textVariant: '#9CA3AF',     // Gray 400
            }),
            ThemeEntity.create({
              code: 'ocean',
              name: 'Océano',
              primary: response.themeConfig.colors.primary,
              secondary: response.themeConfig.colors.secondary,
              surface: '#F0F9FF',
              surfaceVariant: '#E0F2FE',
              text: '#0C1A2E',
              textVariant: '#374151',
            }),
            ThemeEntity.create({
              code: 'forest',
              name: 'Bosque',
              primary: response.themeConfig.colors.primary,
              secondary: response.themeConfig.colors.secondary,
              surface: '#F0FDF4',
              surfaceVariant: '#DCFCE7',
              text: '#052E16',
              textVariant: '#374151',
            }),
          ]);
        })
      );
  }
}
